export function ManualInputLengthCount(manualInflow) {
    let count = 0;
    for (let i = 0; i < manualInflow.length; i++) {
      if (manualInflow[i] !== undefined) {
        count++;
      }
    }
    return count;
}